// src/theme/tokens/blur.js
// Source of truth for Figma blur tokens

export const blur = {
  sm: '4px',
  md: '8px',
  lg: '16px',
};

